import { api } from 'services/DefaultService';
import {
  IArmOrDisarmParams,
  ICreateDeviceToVirtualAlarmCentralParams,
  ICreatePartitionParams,
  IDeletePartitionUserOfVirtualAlarmCentralParams,
  IDeviceVirtualAlarmCentralProps,
  IEventType,
  IEventTypeFirestore,
  IOutputsProps,
  IPartitionProps,
  IUpdateDeviceToVirtualAlarmCentralParams,
  IUpdateOutputsParams,
  IUpdatePartitionParams,
  IUpdatePartitionUserParams,
  IAlarmCentralEventProps,
  IVirtualAlarmCentralProps,
  IVirtualAlarmCentralUpdateParams,
} from './types';
import { IUserProps } from 'services/UserService/types';

export const VIRTUAL_ALARM_CENTRAL_ENDPOINT = 'v1/alarmCentral/virtual';

export const createVirtualAlarmCentral = async (
  params: IVirtualAlarmCentralProps,
): Promise<IVirtualAlarmCentralProps> => {
  try {
    const response = await api.post(VIRTUAL_ALARM_CENTRAL_ENDPOINT, params);
    return response.data;
  } catch (error) {
    throw new Error('Erro na criação da central de alarme virtual.');
  }
};

export const getAllVirtualAlarmCentralByLicense = async (): Promise<any[]> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/getAllByLicense`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      'Erro na busca das centrais de alarme virtual por licença.',
    );
  }
};

export const getAllVirtualAlarmCentralByLoggedUser = async (): Promise<
  any[]
> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/getAllByLoggedUser`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      'Erro na busca das centrais de alarme virtual por usuário logado.',
    );
  }
};

export const armCompleteVirtualAlarmCentralById = async (
  id: number,
): Promise<any[]> => {
  try {
    const response = await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}/arm/complete`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao armar completamente a central de alarme virtual.');
  }
};

export const disarmCompleteVirtualAlarmCentralById = async (
  id: number,
): Promise<any[]> => {
  try {
    const response = await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}/disarm/complete`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao desarmar completamente a central de alarme virtual.',
    );
  }
};

export const armPartialVirtualAlarmCentralById = async ({
  id,
  partitionId,
}: IArmOrDisarmParams): Promise<any> => {
  try {
    await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}/arm/partial/${partitionId}`,
    );
  } catch (error) {
    throw new Error(
      'Erro ao desarmar parcialmente a central de alarme virtual.',
    );
  }
};

export const disarmPartialVirtualAlarmCentralById = async ({
  id,
  partitionId,
}: IArmOrDisarmParams): Promise<void> => {
  try {
    await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}/disarm/partial/${partitionId}`,
    );
  } catch (error) {
    throw new Error(
      'Erro ao desarmar parcialmente a central de alarme virtual.',
    );
  }
};

export const getVirtualAlarmCentralById = async (
  id: number,
): Promise<IVirtualAlarmCentralProps> => {
  try {
    const response = await api.get(`${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar central por ID.');
  }
};

export const updateUpdateVirtualAlarmCentral = async ({
  id,
  alarmCentral,
}: IVirtualAlarmCentralUpdateParams): Promise<IVirtualAlarmCentralProps> => {
  try {
    const response = await api.put(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}`,
      alarmCentral,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao atualizar central por ID: ' + error);
  }
};

export const deleteVirtualAlarmCentralById = async (
  id: number,
): Promise<void> => {
  try {
    await api.delete(`${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${id}`);
  } catch (error) {
    throw new Error('Erro ao excluir central por ID.');
  }
};

export const getAllPartitionsByAlarmCentralId = async (
  alarmCentralId: number,
): Promise<IPartitionProps[]> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar as partições da licença logada.');
  }
};

export const updatePartitions = async ({
  virtualAlarmCentralId,
  partitions,
}: IUpdatePartitionParams) => {
  try {
    await api.put(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${virtualAlarmCentralId}/partition`,
      partitions,
    );
  } catch (error) {
    throw new Error('Erro ao atualizar partições.');
  }
};

export const createPartition = async ({
  partition,
  alarmCentralId,
}: ICreatePartitionParams): Promise<IPartitionProps> => {
  try {
    const response = await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition`,
      partition,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao criar Partição.');
  }
};

export const getAllVirtualAlarmCentralEvents = async (
  alarmCentralId: number,
): Promise<IAlarmCentralEventProps[]> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/events`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar todos os eventos');
  }
};

export const createDeviceToVirtualAlarmCentral = async ({
  alarmCentralId,
  device,
}: ICreateDeviceToVirtualAlarmCentralParams): Promise<void> => {
  try {
    await api.post(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/device`,
      device,
    );
  } catch (error) {
    throw new Error('Erro ao inserir dispositivo.');
  }
};

export const updateDeviceToVirtualAlarmCentral = async ({
  id,
  device,
}: IUpdateDeviceToVirtualAlarmCentralParams): Promise<void> => {
  try {
    await api.put(`${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/device/${id}`, device);
  } catch (error) {
    throw new Error('Erro ao atualizar dispositivo.');
  }
};

export const getDeviceVirtualAlarmCentralById = async (
  id: number,
): Promise<IDeviceVirtualAlarmCentralProps> => {
  try {
    const response = await api.get<IDeviceVirtualAlarmCentralProps>(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/device/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao inserir dispositivo.');
  }
};

export const deleteVirtualAlarmCentralDevice = async (
  id: number,
): Promise<void> => {
  try {
    await api.delete(`${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/device/${id}`);
  } catch (error) {
    throw new Error('Erro ao deletar dispositivo.');
  }
};

export const getAllVirtualAlarmCentralDevices = async (
  alarmCentralId: number,
): Promise<IDeviceVirtualAlarmCentralProps[]> => {
  try {
    const response = await api.get<IDeviceVirtualAlarmCentralProps[]>(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/device`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar dispositivos.');
  }
};

export const getAlllDevicesByPartitionId = async (
  partitionId: number,
): Promise<IDeviceVirtualAlarmCentralProps[]> => {
  try {
    const response = await api.get<IDeviceVirtualAlarmCentralProps[]>(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/partition/${partitionId}/device`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar dispositivo pela partição.');
  }
};

export const getPartitionsUsersOfVirtualAlarmCentralId = async (
  alarmCentralId: number,
): Promise<IUserProps[]> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition/users`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao resgatar os usuários desta central virtual.');
  }
};

export const getPartitionsFromLoggedUserAsync = async (
  alarmCentralId: number,
): Promise<IPartitionProps[]> => {
  try {
    const response = await api.get(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition/getAllByLoggedUser`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao resgatar os usuários desta central virtual.');
  }
};

export const deletePartitionUserOfVirtualAlarmCentralId = async ({
  alarmCentralId,
  userId,
}: IDeletePartitionUserOfVirtualAlarmCentralParams): Promise<void> => {
  try {
    return await api.delete(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition/users/${userId}`,
    );
  } catch (error) {
    throw new Error('Erro ao excluir o usuário desta central virtual.');
  }
};

export const deletePartition = async (id: number): Promise<void> => {
  try {
    return await api.delete(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/partition/${id}`,
    );
  } catch (error) {
    throw new Error('Erro ao excluir partição.');
  }
};

export const updatePartitionsUsersOfVirtualAlarmCentralId = async ({
  alarmCentralId,
  params,
}: IUpdatePartitionUserParams): Promise<IUserProps[]> => {
  try {
    const response = await api.put(
      `${VIRTUAL_ALARM_CENTRAL_ENDPOINT}/${alarmCentralId}/partition/users`,
      params,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao atualizar o usuário referente a esta central virtual.',
    );
  }
};

export const createDescriptionToEventType = (eventType: IEventType) => {
  switch (eventType) {
    case 'FACE_RECOGNITION':
      return 'FACIAL';
    case 'FACIAL':
      return 'FACIAL';
    case 'IVS':
      return 'IVS';
    case 'USER':
      return 'USUÁRIO';
    default:
      return 'LPR';
  }
};

export const createDescriptionToEventFirestoreType = (
  eventType: IEventTypeFirestore,
) => {
  switch (eventType) {
    case 1:
      return 'IVS';
    case 2:
    case 3:
      return 'FACIAL';
    case 6:
      return 'USUÁRIO';
    default:
      return 'LPR';
  }
};
